<template>
  <v-container fill-height fluid>
    <v-layout align-center justify-center>
      <v-flex md4 sm8 xs12>
        <v-card class="elevation-12 pb-1 rounded-lg">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>Вход для работников охраны</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-alert class="rounded-lg mb-8" color="info" outlined v-if="isAuthenticated">
              <div class="text-break">
                <span class="font-weight-bold">Обратите внимание!</span>
                <p class="mt-1 mb-0">У Вас недостаточно прав на использование данного сервиса.
                  Доступ к сервису имеют руководители структурных подразделений и назначенные руководителем заместители.
                  По любым вопросам, связанным с использованием Сервиса заказа и учета пропусков,
                  Вы можете обратиться в Единый центр поддержки пользователей по электронной почте
                  <a href="mailto:support@muctr.ru">support@muctr.ru</a> или по телефону <a href="tel:74992502765">+7 499 250 27 65</a>.</p>
              </div>
            </v-alert>
            <v-form v-model="valid">
              <v-text-field
                  :append-icon="show ? 'visibility_off' : 'visibility'"
                  :type="show ? 'text' : 'password'"
                  :rules="[rules.required, rules.symbControl]"
                  @click:append="show = !show"
                  label="Пароль"
                  outlined
                  class="mb-n6"
                  :loading="loading"
                  prepend-icon="lock"
                  v-model="password"
                  v-on:keyup.enter="login"
              >
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-alert v-if="active == false"  class="ma-4 rounded-lg" type="error">Вы ввели неверный пароль</v-alert>
          <v-layout align-center justify-center>
            <v-card-actions class="mb-6">
              <v-btn :disabled="!valid" @click="login" color="primary" min-width="160" :loading="loading">Вход</v-btn>
            </v-card-actions>
          </v-layout>
          <v-alert  color="info" class="ma-4 rounded-lg" outlined  v-if="!isAuthenticated">
            <div>
              Если у вас возникли трудности с использованием системы, вопросы или предложения, обратитесь в службу технической поддержки <a href="mailto:support@muctr.ru">support@muctr.ru</a>.
            </div>
          </v-alert>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>
import {mapActions, mapGetters} from "vuex";

import admin from "@/urls/roles/admin";
import viewer from "@/urls/roles/viewer";
import entitled from "@/urls/roles/entitled";
import representative from "@/urls/roles/representative";
import guard from "@/urls/roles/guard";

import admin_names from "@/modules/admin/routers/names";
import viewer_names from "@/modules/viewer/routers/names";
import entitled_names from "@/modules/entitled/routers/names";
import representative_names from "@/modules/representative/routers/names";
import guard_names from "@/modules/guard/routers/names";
import names from "@/modules/guard/routers/names";
import user from "@/store/modules/user";

export default {
  // eslint-disable-next-line vue/no-reserved-component-names
  name: "Main",
  data() {
    return {
      loading: false,
      valid: false,
      show: false,
      password: null,
      active: null,
      rules: {
        required: value => !!value || "Введите пароль",
        symbControl: value => this.symbControl(value) || "Некорректный ввод"
      }
    }
  },
  computed: {
    user() {
      return user
    },
    ...mapGetters({
      isAuthenticated: "user/isAuthenticate"
    })
  },
  methods: {
    ...mapActions({
      loginGuard: "guard/loginGuard"
    }),
    login() {
      this.loading = true
      let data = {
        password: this.password
      }
      this.loginGuard({
        data,
        finalizer: (val) => {
          this.loading = false
          if(val.active){
            window.$cookies.set("guard_hash", val.guard_hash)
            if(window.$cookies.get("guard_hash")){
              this.$router.push({name: guard_names.ORDERS.LIST}).catch(() => {})
            }
          }
          else
            this.active = val.active
        },
        catcher:(val) => {
          this.loading = false
          this.mapErrors(val)
        }
      })
    },
    symbControl: function (value) {
      if(value === null)
        return true
      return !(value.includes(" ") || value.includes("\n"));
    }
  },
  created() {
    this.$store.commit("leftmenu/dissable");
    if(this.$route.query.password){
      this.password = this.$route.query.password
      this.login()
    }
    else if (window.$cookies.get("guard_password")){
      this.password = window.$cookies.get("guard_password")
      this.login()
    }
  }

}
</script>

<style scoped>

</style>




